import { IWorkInstructionDTO } from "../../common/types";
import { GetMethod } from "../../methods/GetMethod";

export class GetWorkInstructionByIdEndpoint extends GetMethod<IWorkInstructionDTO> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/workinstructions`);
  }
}
